// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ProProfileDetails from './components/ProProfileDetails'
import ProProfileTabs from './components/ProProfileTabs'
import VTooltip from 'v-tooltip'
import '../../css/tooltip.css'
import store from "../../../store";
import {VueMasonryPlugin} from "vue-masonry";

Vue.use(VTooltip);
Vue.use(VueMasonryPlugin);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#proProfile',
  store,
  components: { ProProfileDetails, ProProfileTabs},
})




// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/modules/pro/profile/index.js